/**
 * Ryan O'Dowd
 * 2024-09-22
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    container: {
      flexGrow: 1,
    },
    widgetInner: {
      backgroundColor: `${colors.primaryDark}44`, // @TODO: abstract with friends widget
      borderRadius: 8,
      flexGrow: 1,
      marginBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      margin: 4,
    },
    widgetInnerNoMargin: {
      margin: 0,
    },
    widgetInnerNoBackground: {
      backgroundColor: 'transparent',
    },
  };
};

export default getStyles;
